export const initXRSession = ({
	renderer,
	sessionType,
	optionalFeatures = [],
	onXrSessionStarted,
	onXRSessionEnd,
}) => {
	const sessionInit = {
		optionalFeatures: [
			'local-floor',
			'bounded-floor',
			'layers',
			'depth-sensing',
			...optionalFeatures,
		],
	};
	return navigator.xr
		.requestSession(sessionType, sessionInit)
		.then((session) => {
			onXrSessionStarted(true);
			session.addEventListener('end', onXRSessionEnd);
			return renderer.xr.setSession(session);
		});
};

export const addCameraToDolly = (camera, dolly, browser, scene) => {
	dolly.add(camera);
	dolly.rotation.y += Math.PI / 2;

	// Reset camera position
	if (browser === 'Safari') {
		const cubeBackground = scene.children.find(
			(child) => child.name === 'cubeBackground',
		);

		if (cubeBackground) {
			cubeBackground.scale.multiplyScalar(5);
		}
	}

	console.log('camera and dolly', dolly.position, camera.position);
};

export const removeCameraFromDolly = (camera, dolly, browser, scene) => {
	dolly.remove(camera);
	dolly.rotation.y -= Math.PI / 2;

	// Reset camera position
	if (browser === 'Safari') {
		const cubeBackground = scene.children.find(
			(child) => child.name === 'cubeBackground',
		);

		if (cubeBackground) {
			cubeBackground.scale.multiplyScalar(0.2);
		}

		camera.updateProjectionMatrix();
	}
};
